import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footerInner">
          <span className="muted">© {new Date().getFullYear()} John Hash</span>
          <a className="muted" href="#about">Back to top ↑</a>
        </div>
      </div>
    </footer>
  );
}